import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'ppl-google-translate',
  standalone: true,
  imports: [],
  templateUrl: './google-translate.component.html',
  styleUrl: './google-translate.component.css'
})
export class GoogleTranslateComponent implements AfterViewInit {

  ngAfterViewInit() {
    this.loadGoogleTraslateScript();
  }

  loadGoogleTraslateScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    document.body.appendChild(script);

    (window as any).googleTranslateElementInit = () => {
      new (window as any).google.translate.TranslateElement({pageLanguage: 'en', layout: (window as any).google.translate.TranslateElement.InlineLayout.VERTICAL},
        'google_translate_element'
      );
      
      // Use MutationObserver to apply styles when element loads
      this.waitForElementAndStyle();
    };
  }

  waitForElementAndStyle() {
    const googleTranslateElement = document.getElementById('google_translate_element');
    
    if (googleTranslateElement && googleTranslateElement.children.length > 0) {
      // Element already exists, apply styles immediately
      this.styleGoogleTranslateSelect();
    } else {
      // Wait for the element to be populated using MutationObserver
      const observer = new MutationObserver(() => {
        const select = document.querySelector('select.goog-te-combo');
        if (select) {
          observer.disconnect();
          this.styleGoogleTranslateSelect();
        }
      });

      const config = {
        childList: true,
        subtree: true,
        attributes: false
      };

      if (googleTranslateElement) {
        observer.observe(googleTranslateElement, config);
      }
    }
  }

  styleGoogleTranslateSelect() {
    // Inject CSS to hide Google Translate branding and "Powered by" text
    const style = document.createElement('style');
    style.innerHTML = `
      /* Hide the entire gadget wrapper except the select */
      .goog-te-gadget {
        color: transparent !important;
        font-size: 0 !important;
      }
      
      /* Show only the select element */
      .goog-te-gadget select.goog-te-combo {
        font-size: 13px !important;
        color: white !important;
      }
      
      /* Hide Google logo and branding */
      .goog-logo-link,
      .goog-te-gadget span,
      .goog-te-gadget > span,
      .goog-te-banner-frame {
        display: none !important;
        visibility: hidden !important;
      }
      
      /* Hide "Powered by" text by making parent transparent */
      .goog-te-gadget > div {
        display: inline-block !important;
      }
      
      /* Ensure select is visible */
      #google_translate_element .goog-te-gadget select {
        display: inline-block !important;
        visibility: visible !important;
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);

    const translateSelect: HTMLSelectElement | null = document.querySelector('select.goog-te-combo');
    
    if (translateSelect) {
      // Apply inline styles directly
      translateSelect.style.backgroundColor = '#004C4A';
      translateSelect.style.color = 'white';
      translateSelect.style.border = '1px solid rgba(255, 255, 255, 0.3)';
      translateSelect.style.borderRadius = '6px';
      translateSelect.style.padding = '3px';
      translateSelect.style.fontWeight = '500';
      translateSelect.style.cursor = 'pointer';
      translateSelect.style.fontFamily = 'Outfit, sans-serif';
      
      // Style options
      const options = translateSelect.querySelectorAll('option');
      options.forEach((option) => {
        option.style.backgroundColor = '#004C4A';
        option.style.color = 'white';
      });
      
      // Add hover effect
      translateSelect.addEventListener('mouseenter', () => {
        translateSelect.style.backgroundColor = '#005c56';
        translateSelect.style.borderColor = 'rgba(255, 255, 255, 0.5)';
      });
      
      translateSelect.addEventListener('mouseleave', () => {
        translateSelect.style.backgroundColor = '#004C4A';
        translateSelect.style.borderColor = 'rgba(255, 255, 255, 0.3)';
      });
      
      // Add focus state styling to override default black border
      translateSelect.addEventListener('focus', () => {
        translateSelect.style.outline = 'none';
        translateSelect.style.boxShadow = '0 0 0 2px rgba(255, 255, 255, 0.3)';
        translateSelect.style.backgroundColor = '#005c56';
        translateSelect.style.borderColor = 'rgba(255, 255, 255, 0.5)';
      });
      
      translateSelect.addEventListener('blur', () => {
        translateSelect.style.outline = 'none';
        translateSelect.style.boxShadow = 'none';
        translateSelect.style.backgroundColor = '#004C4A';
        translateSelect.style.borderColor = 'rgba(255, 255, 255, 0.3)';
      });
    }
    
    // Remove "Powered by" text nodes
    const googleTranslateElement = document.getElementById('google_translate_element');
    if (googleTranslateElement) {
      const gadget = googleTranslateElement.querySelector('.goog-te-gadget');
      if (gadget) {
        // Remove all text nodes (including "Powered by")
        Array.from(gadget.childNodes).forEach(node => {
          if (node.nodeType === Node.TEXT_NODE) {
            node.remove();
          }
        });
      }
    }
  }

  autoTranslate(lang: string): void {
    const translateCode: HTMLSelectElement | null = document.querySelector('select.goog-te-combo');
    if (translateCode) {
      translateCode.value = lang;
      translateCode.dispatchEvent(new Event('change'));
    }
  }
}

